<template>
    <span @click.stop>
        <category-header
                    v-if="categories.length"
                    :title="resolveCategoryName(category)"
                    :active="dropdownVisible"
                    :loading="loading"
                    @click="onToggleBar"
        />
        <ul v-else class="item">
            <li>
                <label class="radio">
                    <input
                        type="checkbox"
                        :checked="categoryIsSelected(category)"
                        @change="checkItem(category)"
                    />
                    <div>{{ resolveCategoryName(category) }}</div>
                </label>
            </li>
        </ul>
        <ul v-if="dropdownVisible" class="item-child">
            <template v-for="category in categories">
                <li class="level-2">
                    <label class="radio">
                        <input type="checkbox"
                               :checked="categoryIsSelected(category)"
                               @change="checkItem(category)"
                        />
                        <div>{{ resolveCategoryName(category) }}</div>
                    </label>
                </li>
            </template>
        </ul>
    </span>
</template>

<script>
    import CategoryHeader from "./CategoryHeader";
    import EventBus from "../services/EventBus"
    import CategoryNameResolver from "../mixins/CategoryNameResolver";

    export default {
        name: "ItemCategory",
        mixins: [
            CategoryNameResolver
        ],
        components: {CategoryHeader},
        props: {
            category: Object,
            checkedCategories: {
                type: Array,
                default: () => []
            },
            hideGroupOnClick: {
                type: Boolean,
                default: true,
            },
            loading: Boolean,
        },
        data() {
            return {
                dropdownVisible: false,
            }
        },
        computed: {
            categories() {
                return this.category.children;
            }
        },
        methods: {
            onToggleBar() {
                if (!this.dropdownVisible) {
                    EventBus.$emit('category-dropdown-hide');

                    if (this.hideGroupOnClick) {
                        EventBus.$emit('category-group-hide');
                    }
                }

                this.dropdownVisible = !this.dropdownVisible;
            },

            categoryIsSelected(category) {
                return this.checkedCategories.includes(category.id);
            },

            checkItem(category) {
                if (this.categoryIsSelected(category)) {
                    this.$emit('remove-category', category.id)
                } else {
                    this.$emit('check-category', category.id)
                }
            }
        },
        mounted() {
            EventBus.$on('category-dropdown-hide', () => {
                this.dropdownVisible = false;
            })
        }
    }
</script>

<style scoped lang="scss">

    $radioSize: 18px;
    $radioBorder: #333333;
    $radioDisable: #ffffff;
    $radioActive: #1A3A37;

    .radio {
        padding: 12px 0;
        display: block;
        cursor: pointer;
        input {
            display: none;
            & + div {
                line-height: $radioSize;
                padding-left: $radioSize;
                display: block;
                position: relative;
                &:not(:empty) {
                    padding-left: $radioSize + 8;
                }
                &:before,
                &:after {
                    content: "";
                    width: $radioSize;
                    height: $radioSize;
                    display: block;
                    border-radius: 3px;
                    border: 1px solid $radioActive;
                    left: 0;
                    top: 0;
                    position: absolute;
                }
                &:before {
                    background: $radioBorder;
                    transition: background .1s ease, transform .2s cubic-bezier(.175, .885, .32, 2);
                }
                &:after {
                    background-color: $radioDisable;
                    //transform: scale(.78);
                    transition: transform .2s cubic-bezier(.175, .885, .32, 1.4);
                }
            }
            &:checked + div {
                &:before {
                    background: $radioActive;
                }
                &:after {
                    font-size: 20px;
                    font-weight: normal;
                    content: "L";
                    -ms-transform: scaleX(-1) rotate(-35deg); /* IE 9 */
                    -webkit-transform: scaleX(-1) rotate(-35deg); /* Chrome, Safari, Opera */
                    transform: scaleX(-1) rotate(-35deg);
                    top: -4px;
                    left: -4px;

                    background-color: transparent;
                    border: 0 none;
                    color: #ffffff;
                }
            }
        }
    }

    .mobile-item {
        & ul.item,
        & ul.item-child {
            width: 100%;
            box-sizing: border-box;
            margin: 0;
            padding: 0 20px 0 14px;
            background-color: #ffffff;
            -moz-box-shadow: 0 4px 2px #ccc;
            -webkit-box-shadow: 0 4px 2px #ccc;
            box-shadow: 0 4px 2px #ccc;
            overflow: auto;

            @media (max-width: 1024px) {
                max-height: none !important;
            }

            & li {
                font-size: 14px;
                color: #000000;
                list-style-type: none;
                margin: 0;
                padding: 0;
            }
            & li.level-2 {
                margin-left: 20px;
            }
        }
        & ul.item-child {
            padding-top: 0;
            padding-bottom: 20px;
        }
    }

    @media (max-width: 960px) {
        .mobile-item {
            & ul.item {
                max-width: 100%;
            }
        }
    }

    #for ul.item,
    #occasions ul.item {
        position: relative;
        padding-bottom: 0;
        max-width: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

</style>
